/**
 * A QUE NEGOCIO VA UNA SUBIDA AL SYNC (SEC-SYNC-NEGOCIO-T1, lado panel; COORD de Argy-A #15532).
 *
 * DE DONDE SALE. El carrito y el conteo de inventario subian a POST /api/sync/upload con
 * `business_id: bizId || 'default'`. Cuando nadie habia elegido negocio (un admin de Nexo
 * que abre #/carrito sin seleccionar), el pedido o el conteo quedaba guardado en un
 * negocio 'default' que no existe: filas huerfanas que ningun Desktop descarga. Con el
 * api 269 el sync ata la credencial al negocio y esa subida recibe 403.
 *
 * LA REGLA: sin negocio real no se envia ni se encola. La vista lo dice y el trabajo
 * del colaborador (el carrito, el borrador del conteo) se queda donde esta.
 *
 * Sin DOM: lo prueba scripts/check-subida-con-negocio.mjs.
 */

export const MENSAJE_SIN_NEGOCIO =
  'Elige el negocio arriba antes de enviar. Sin negocio el envio no llega a ningun Desktop, asi que no se manda nada y lo que llevas se queda aqui.';

/** El negocio al que va la subida, o null si no hay uno real ('', espacios o 'default'). */
export function negocioDeLaSubida(bizId) {
  if (typeof bizId !== 'string') return null;
  const id = bizId.trim();
  if (id === '' || id.toLowerCase() === 'default') return null;
  return id;
}
